var map = {
	"./y_2000.png": 74522,
	"./y_2005.png": 81991,
	"./y_2010.png": 26533,
	"./y_2015.png": 92408,
	"./y_2020.png": 61024,
	"./y_2025.png": 13037,
	"./y_2030.png": 61675,
	"./y_2035.png": 7046,
	"./y_2040.png": 48726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15671;